import { render, staticRenderFns } from "./LayoutFolder.vue?vue&type=template&id=bcabce3a&scoped=true&"
import script from "./LayoutFolder.vue?vue&type=script&lang=js&"
export * from "./LayoutFolder.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFolder.vue?vue&type=style&index=0&id=bcabce3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcabce3a",
  null
  
)

export default component.exports